import {
  companyTypeOf,
  COMPANY_SEGMENT_LABELS,
  type CompanyType,
} from "@repo/types";

/**
 * VRG-808 — the Type of a company as it arrives from `/companies/admin` THROUGH
 * `listedCompanies()`, and the one-word badge for it.
 *
 * Extracted on the third hand-roll (§36): EncodeTagsModal, SetPackageCompanyModal and
 * PackageBoxModal all admit demo companies into a picker and all have to answer "is this a
 * demo?" the same way. Three copies of the same `companyTypeOf({...})` call is three places
 * to get the defaulting wrong.
 *
 * ⚠️ `is_test` / `is_example` are hardcoded false, and that is a REAL limit, not laziness.
 * `listedCompanies()` unwraps the list ROW (which carries a computed `company_type`) down to
 * the nested company ENTITY, and that entity carries `kind` but neither flag. So this resolves
 * `demo` and `internal` and returns null for an example or test company. Those two were never
 * excluded from these pickers either, so they have always rendered unlabelled — this does not
 * regress them, it just cannot fix them. Widening means surfacing `company_type` through
 * `listedCompanies`.
 */
export const listedCompanyType = (c: {
  kind?: string | null;
}): CompanyType | null =>
  companyTypeOf({
    kind: c.kind ?? "standard",
    is_test: false,
    is_example: false,
  });

/** The right-aligned `SelectItem.rightLabel` for a picker option — undefined for a plain company. */
export const companyLabel = (kind?: string | null): string | undefined => {
  const type = listedCompanyType({ kind });
  return type ? COMPANY_SEGMENT_LABELS[type] : undefined;
};
